<template>
    <div class="thirdStep">
      <div class="flieName_box">
        <div class="btn">
          <label>成绩单名称：</label>
          <el-input v-model="obj.origName" ></el-input>
        </div>
      </div>
      <div class="table_box">
        <div class="upload_box">
          <!-- <p>成功上传信息<span style="color:#1890FF">{{allPage}}</span>条 错误信息<span style="color:#EC3441">{{errPage}}</span>条</p> -->
          <p>
            <a href="javascript:;" class="change-btn" @click="batchDeleted">批量删除</a>
            <a href="javascript:;" class="change-btn" @click="allDerive">批量导出</a>
          </p>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%;" :header-cell-style="{background:'#F4F8FE',padding:'8px 0',color:'#191919'}" v-el-table-infinite-scroll="load" v-if="compile">
          <el-table-column  show-overflow-tooltip type="selection" :selectable='checkboxT' width="55" align="center">
          </el-table-column>
          <el-table-column
                  label="序号"
                  type="index"
                  width="50"
                  align="center">
          </el-table-column>
          <template v-for="(item,index) in tableHead">
            <el-table-column :key="index"  align="center" :label="item.value" min-width="100">
              <template slot-scope="scope">
                <span  class="overSpan" :title="scope.row['obj'+index].value">{{scope.row['obj'+index].value}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" :min-width='120'>
            <template slot-scope="scope">
              <a href="javascript:;" class="list-btn" style="border-right:none"   @click="compilefun(scope.row)">编辑</a>
              <el-popconfirm
                confirmButtonText='好的'
                cancelButtonText='不用了'
                icon="el-icon-info"
                iconColor="red"
                title="确定删除该条信息吗？"
                @onConfirm="del(scope.row)"
              >
                 <a href="javascript:;" slot="reference" class="list-btn" style="border-right:none" >删除</a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn_box">
        <a href="javascript:;" class="border-btn" @click="setActive(2)">上一步</a>
        <a href="javascript:;" class="change-btn" @click="allImport">完成</a>
      </div>

      <el-dialog
        title="编辑"
        v-if="dialog"
        :visible.sync="dialog"
        width="739px"
        center>
        <el-form label-width="80px" label-position="left" style="padding:0 40px;overflow: hidden;">
          <el-row :gutter="20">
            <el-col span="12" v-for="(item,index) in tableHead" :key="index">
              <el-form-item :label="item.value">
                <el-input v-model="form['obj'+index].value"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog = false">取 消</el-button>
          <el-button type="primary" @click="submitBtn">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        class="shareShow"
        :visible.sync="shareShow"
        width="537px"
        @close="goBack"
        center>
        <div class="sharebox">
          <div class="share_left">
            <span><i class="el-icon-check"></i></span>
            <p>成功上传成绩单</p>
            <div>
              <p>分享查询链接</p>
              <el-input v-model="shareLink"></el-input>
              <a href="javascript:;" class="change-btn" @click="copy">复制</a>
            </div>
          </div>
          <div class="share_right">
            <p>扫一扫分享成绩单</p>
            <div class="qrcode"></div>
          </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import { getNotLoginList,updateValue,delNotLoginData,importDate,notLoginExport,updateTranscript,scoreDelete,updateState } from '@/api/common_api'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import QRCode from 'qrcodejs2'
export default {
  data(){
    return{
      name:'',
      dialog:false,
      form:{},
      tableData:[],
      compile:false,
      limit: 10,
      offset: 1,
      total:0,
      tableHead:[],
      tableCus:[],
      potionts:false,
      shareShow:false,
      shareLink:''
    }
  },
  props:{
    obj:{
      type:Object
    }
  },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  created(){
    this.getTable()
    
  },
  methods:{
    getTable(){
      getNotLoginList({id:this.$parent.transcriptId}).then(res=>{
        if(res.s==1){
          let data = res.d.att,tableDate=[]
          this.tableHead =[]
          data.map((item,index)=>{
            this.tableHead.push({value:item.name})
            item.val.map((val,num)=>{
              if(!tableDate[num]){
                tableDate[num] = {}
              }
              tableDate[num]['obj'+index] = val
            })
            return item
          })
          this.shareLink = res.d.shareLink
          this.compile=true
          this.tableData = tableDate
        }
      })
    },
    //导入到正式表
    allImport(){
      if(!this.obj.origName.length){
        this.$message.error('请先填写成绩单名称')
        return false
      }
      updateTranscript({id:this.$parent.transcriptId,name:this.obj.origName}).then(res=>{
        if(res.s==1){
          this.shareShow = true
          this.$nextTick(() => {
            document.getElementsByClassName('qrcode')[0].innerHTML=""
            let qrcode=new QRCode(document.getElementsByClassName('qrcode')[0],{
              width:112,
              height:112,
              text:this.shareLink,
              colorDark:'#000',
              colorLight:'#fff',
              render: 'table' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            })
          })
        }
      })
      updateState({id:this.$parent.transcriptId,state:1})
      
    },
    //批量导出
    allDerive(){
      notLoginExport({id:this.$parent.transcriptId}).then(res =>{
        if(res.s == 1){
          this.$message({
            message: '导出文件成功',
            type: 'success'
          })
          this.$notify({
            title: `导出文件成功`,
            type: 'success',
            dangerouslyUseHTMLString: true,
            duration: 3000,
            offset: 60,
            message: `<iframe src='${window.location.origin+res.d.filePath}' style="display:none"></iframe>`
          })
        }else{
          this.$message.error(res.d)
        }
      })
    },
    //批量删除
    batchDeleted(){
      let data=this.$refs.multipleTable.store.states.selection,ids=[]
      data.map(val=>{
        for(let obj in val){
          ids.push(val[obj].id)
        }
      })
      if(!ids.length){
        this.$message.error('请选择数据')
        return false
      }
      delNotLoginData({ids:ids.join(',')}).then(res=>{
        if (res.s == 1) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTable()
        } else {
          this.$message.error(res.d)
        }
      })
      
    },
    //删除按钮
    del(row){
      let ids=[]
      for(let obj in row){
        ids.push(row[obj].id)
      }
      delNotLoginData({ids:ids.join(',')}).then(res=>{
        if (res.s == 1) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTable()
        } else {
          this.$message.error(res.d)
        }
      })
    },
    //编辑按钮
    compilefun(row){
      this.form = JSON.parse(JSON.stringify(row))
      this.dialog = true
    },
    submitBtn(){
      this.upDate(this.form)
    },
    upDate(obj){
      let form ={},ary=[]
      for(let key in obj){
        ary.push(obj[key])
      }
      ary.map((item,value)=>{
        form[`val[${value}].id`] = item.id
        form[`val[${value}].value`] = item.value
        return item
      })
      // console.log(form)
      // return false
      updateValue(form).then(res => {
        if(res.s == 1){
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        }else{
          this.$message.error(res.d)
        }
        this.dialog = false
        this.getTable()
      }).catch(e=>{
        this.getTable()
      })
    },
    load() {
      // if(this.tableData.length>=this.total && this.compile){
      //   return false
      // }
      // this.offset++
      // this.getTable()
    },
    //编辑
    compile(item){
      this.dialog = true
    },
    copy(){
      var oInput = document.createElement('input');
        oInput.value = this.shareLink;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = 'oInput';
        oInput.style.display='none';
        this.$message({
          message: '复制成功',
          type: 'success'
        });
       
    },
    goBack(){
      this.$router.push({path:'/gardeType'})
    },
    setActive(val){
      this.$parent.setActive(val)
      scoreDelete({id:this.$parent.transcriptId})
    }
  }
}
</script>
<style lang="less" scoped>
.thirdStep{
  font-size: 14Px;
  margin-top: 24Px;
  .flieName_box{
    display: flex;
    justify-content: space-between;
    .btn{
      margin-left: 7Px;
      /deep/ .el-input{
        width: 224Px;
        margin-right: 14Px;
      }
    }
  }
  .table_box{
    width: 805Px;
    .upload_box{
      display: flex;
      flex-direction: row-reverse;
      line-height: 36Px;
      margin: 20Px 0 16Px 0;
      padding-left: 7Px;
      a{
        margin-left: 30Px;
        margin-right: 4Px;
      }
    }
    /deep/ .el-table td{
      padding: 4Px 0;
    }
  }
  .btn_box{
    margin-top: 36Px;
    text-align: center;
    .change-btn{
      margin-left: 34Px;
    }
  }

  .shareShow{
    /deep/ .el-dialog__headerbtn{
      top: 13Px;
      right: 12Px;
      border: 1px solid #1890FF;
      width: 20Px;
      height: 20Px;
      box-sizing: border-box;
      border-radius: 50%;
      /deep/ .el-dialog__close{
        color: #1890FF;
        line-height: 18Px;
      }
    }
    /deep/ .el-dialog__body{
      padding: 0  34Px 29Px;
    }
  }
  .sharebox{
    display: flex;
    justify-content: space-between;
    &>div{
      height: 206Px;
    }
    .share_left{
      text-align: center;
      padding-right: 31Px;
      border-right: 1px solid #EEEEEE;
      span{
        display: inline-block;
        width: 33Px;
        height: 32Px;
        background: #4FC517;
        line-height: 32Px;
        font-size: 24Px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        font-weight: bold;
        margin-top: 24Px;
      }
      p{
        font-size: 16Px;
        color: #444444;
        margin-top: 15Px;
      }
      div{
        text-align: left;
        /deep/ .el-input{
          width: 191Px;
          margin-right: 12Px;
        }
        p{
          font-size: 14Px;
          margin-bottom: 10Px;
        }
      }
    }
    .share_right{
      text-align: center;
      p{
        font-size: 16Px;
        color: #444;
        margin: 23Px 0 15Px;
      }
      .qrcode{
        width: 124Px;
        height: 124Px;
        padding: 6Px;
        box-sizing: border-box;
        margin: 0 auto;
        box-shadow:0px 1Px 6Px 0px rgba(0, 0, 0, 0.5)
      }
    }
  }
}

/deep/ .el-table .cell{
  padding: 0;
}

</style>